import { Design } from '../../../types';
import { downloadCsv } from '../../../utilities';
import { DuplicateIdItem } from './get-duplicate-id-items';

/**
 * Options to group duplicate node IDs in different ways.
 *
 * @property label Label displayed to the user.
 * @property value.groupKey Property of an item used to assign it to a group.
 * @property value.groupLabel Label displayed prior to the group's value.
 * @property value.itemKey Property of an item used to differentiate between items in the same group (node name is not always unique).
 * @property value.itemLabel Label displayed prior to the item's value.
 */
const duplicateIdGroupByOptions = [
  {
    label: 'Module',
    value: {
      groupKey: 'moduleName',
      groupLabel: 'Module',
      itemKey: 'id',
      itemLabel: 'ID'
    }
  },
  {
    label: 'ID',
    value: {
      groupKey: 'id',
      groupLabel: 'ID',
      itemKey: 'moduleName',
      itemLabel: 'Module'
    }
  }
] as const;

export type DownloadDuplicateIdCsvProps = {
  duplicateIdItems: DuplicateIdItem[];
  serialized: Design;
};

/** Download a CSV with the provided duplicate ID items in it.  */
export function downloadDuplicateIdCsv({
  duplicateIdItems,
  serialized
}: DownloadDuplicateIdCsvProps) {
  const {
    application,
    client,
    version
  } = serialized;
  const [
    firstColumn,
    ...restColumns
  ] = duplicateIdGroupByOptions.map((option) => {
    return option.value;
  });

  downloadCsv({
    columns: [
      {
        getter: firstColumn.groupKey,
        label: firstColumn.groupLabel
      },
      {
        getter: 'type',
        label: 'Type'
      },
      {
        getter: 'name',
        label: 'Name'
      },
      ...restColumns.map(({ groupKey, groupLabel }) => {
        return {
          getter: groupKey,
          label: groupLabel
        };
      })
    ],
    fileName: `${client}-${application}-${version}-DuplicateIds.csv`,
    items: duplicateIdItems
  });
}
